import ArchiveButton from './ArchiveButton.view';
export default ArchiveButton;
